<template>
  <div class="container">
    <!-- 密码验证对话框 -->
    <el-dialog
      title="访问验证"
      :visible.sync="passwordDialogVisible"
      width="300px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :modal="false"
      custom-class="password-dialog">
      <div class="password-container">
        <el-input
          v-model="inputPassword"
          type="password"
          placeholder="请输入访问密码"
          prefix-icon="el-icon-lock"
          @keyup.enter.native="verifyPassword">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="verifyPassword">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 页面内容，仅在验证通过后显示 -->
    <template v-if="isAuthenticated">
      <h1 class="title"><i class="el-icon-menu"></i> 数据看板</h1>

      <!-- 功能卡片区域 -->
      <div class="card-container">
        <el-card class="function-card" shadow="hover" @click.native="navigateTo('custom')">
          <div class="card-icon">
            <i class="el-icon-data-analysis"></i>
          </div>
          <div class="card-title">省单一窗口覆盖率看板</div>
          <div class="card-desc">查看福州海关各关区票数占比</div>
        </el-card>

        <el-card class="function-card" shadow="hover" @click.native="navigateTo('company')">
          <div class="card-icon">
            <i class="el-icon-s-grid"></i>
          </div>
          <div class="card-title">企业明细数据</div>
          <div class="card-desc">查看企业明细数据及相关统计信息</div>
        </el-card>
      </div>
    </template>
  </div>
</template>

<script>
import { verifyPassword, codeFlag } from '@/api/app'
import { Base64 } from 'js-base64'
export default {
  data() {
    return {
      // 密码验证相关数据
      passwordDialogVisible: false,
      inputPassword: '',
      isAuthenticated: false,
      code: '' // 保存验证后的code
    }
  },
  created() {
    // 从localStorage获取code
    const savedCode = localStorage.getItem('authCode')
    if (savedCode) {
      // 验证code是否有效
      codeFlag(savedCode).then(res => {
        if (res.data) {
          // code有效，直接认证通过
          this.isAuthenticated = true
          this.passwordDialogVisible = false
          this.code = savedCode
        } else {
          // code无效，清除localStorage
          localStorage.removeItem('authCode')
        }
      }).catch(() => {
        // 验证失败，清除localStorage
        localStorage.removeItem('authCode')
      })
    } else {
      this.passwordDialogVisible = true
    }
  },
  methods: {
    // 验证密码
    verifyPassword() {
      const decode = Base64.encode(this.inputPassword)
      // 调用接口
      verifyPassword(decode).then(res => {
        if (res.data.flag === 'true') {
          this.isAuthenticated = true
          this.passwordDialogVisible = false
          this.$message({
            message: '验证成功，欢迎访问！',
            type: 'success',
            duration: 2000
          })
          console.log(res.data)
          // 保存code
          this.code = res.data.code
          // 将code存储到localStorage，以便子页面使用
          localStorage.setItem('authCode', this.code)
        } else {
          this.$message({
            message: '密码错误，请重新输入！',
            type: 'error',
            duration: 2000
          })
          this.inputPassword = ''
        }
      })
    },
    // 导航到指定页面
    navigateTo(route) {
      this.$router.push({
        path: route
      })
    }
  },
  // 提供给子组件的数据
  provide() {
    return {
      getAuthCode: () => this.code // 提供一个方法让子组件获取code
    }
  }
}
</script>

<style scoped>

.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f5f7fa;
  min-height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* 密码框样式 */
.password-container {
  margin: 20px 0;
}

.title {
  color: #333;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  margin: 0 0 20px 0;
  border-bottom: 1px solid #dcdfe6;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}

.title i {
  margin-right: 8px;
  color: #409EFF;
}

.card-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.function-card {
  cursor: pointer;
  transition: all 0.3s;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
}

.function-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.card-icon {
  font-size: 48px;
  color: #409EFF;
  margin-bottom: 15px;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}

.card-desc {
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .container {
    padding: 15px;
  }

  .title {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .card-container {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .function-card {
    height: 180px;
    padding: 15px;
  }

  .card-icon {
    font-size: 40px;
    margin-bottom: 10px;
  }

  .card-title {
    font-size: 16px;
  }

  .card-desc {
    font-size: 13px;
  }
}
</style>
